import type { DealOption } from '@/types';

/**
 * Dealbedrag in hele eenheden, zoals in het overzicht. Een leeg of nulbedrag
 * zegt bij het kiezen niets en laten we weg.
 */
export function formatDealAmount(deal: Pick<DealOption, 'amount' | 'currency'>): string | null {
  if (deal.amount == null || !Number.isFinite(deal.amount) || deal.amount === 0) return null;
  const options = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  try {
    return new Intl.NumberFormat('nl-NL', { ...options, style: 'currency', currency: deal.currency || 'EUR' }).format(
      deal.amount,
    );
  } catch {
    // Onbekende valutacode uit HubSpot: dan het getal met de code erachter.
    return `${new Intl.NumberFormat('nl-NL', options).format(deal.amount)} ${deal.currency}`;
  }
}

/** Bedrijf, fase en eigenaar: waarmee je twee deals met dezelfde naam uit elkaar houdt. */
export function dealDetails(deal: DealOption): string[] {
  return [deal.companyName, deal.stageLabel, deal.ownerName].filter((value): value is string => Boolean(value?.trim()));
}
